import { FC } from 'react';
import { AdvancedFilterRow } from 'shared/components/AdvancedFilter/components/AdvancedFilterRow';
import { HouseAreaContainer, LandAreaContainer } from './containers';
import { InlineFilterGroup } from 'shared/components/InlineFilterGroup';

export const SuburbanAreaContainer: FC = () => {
  return (
    <AdvancedFilterRow label="Площадь">
      <InlineFilterGroup>
        <HouseAreaContainer />
        <LandAreaContainer />
      </InlineFilterGroup>
    </AdvancedFilterRow>
  );
};
